module.exports = __webpack_public_path__ + "static/img/evaluation_fail.848cc7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/basic/card/img/evaluation_fail.png
// module id = ynFp
// module chunks = 1